import React, { useState, useRef, useEffect } from 'react';

import { Intents } from '../constants/order';

const calcRemainingTime = expiry_time => {
    const now = new Date().getTime();
    const expiry = new Date(expiry_time).getTime();
    return expiry - now;
};

const calcPercent = (start, end) => 100 - Math.floor((start / end) * 100);

const validPercentage = int => int > 0 && int < 100;

// TODO - review and revrite this component
// add proptypes
// ask Jens about DH Ghost and DH Broker
const GridTableCell = props => {
    const {
        price,
        columnName,
        expiry_time,
        placeOrder,
        getOrder,
        intent,
        setToExpired,
        isGlowing,
        showCreateOrder,
        isOwner,
        isExpired,
    } = props;

    const maxTimeLeftMillis = 60 * 2 * 1000;

    const calcTableItemClass = () => {
        let classname = 'OnlineMarketsGridViewItemTableItem ';
        if (typeof price === 'number') {
            classname += ' Number';
        }
        if (['Act', 'Bid', 'Offer'].includes(columnName)) {
            classname += ' Clickable';
        }

        if (intent === Intents.BUY) {
            classname += ' Buy';
        }

        if (intent === Intents.SELL) {
            classname += ' Sell';
        }

        const percentageDone = calcPercent(calcRemainingTime(expiry_time), maxTimeLeftMillis);
        classname += validPercentage(percentageDone) ? ' TimeLimit' : ' Regular';

        if (isGlowing && !isExpired) {
            classname += ' Glowing';
        }

        return classname;
    };

    const useInterval = (callback, delay) => {
        const savedCallback = useRef();

        useEffect(() => {
            savedCallback.current = callback;
        }, [callback]);

        useEffect(() => {
            const tick = () => {
                savedCallback.current();
            };
            if (delay !== null) {
                const id = setInterval(tick, delay);
                return () => clearInterval(id);
            }
        }, [delay]);
    };

    const [state, setState] = useState({
        timeLeftPercent: undefined,
        showLinearTimeIndicator: false,
    });

    const [hovering, setHovering] = useState(false);

    const onMouseEnter = () => setHovering(true);

    const onMouseLeave = () => setHovering(false);

    const timer = useInterval(
        () => {
            const remainingTime = calcRemainingTime(expiry_time);
            if (remainingTime > -1) {
                const percentageDone = calcPercent(remainingTime, maxTimeLeftMillis);
                const shouldShowlinearTimeIndicator = validPercentage(percentageDone);

                setState({
                    timeLeftPercent: 100 - percentageDone,
                    showLinearTimeIndicator: shouldShowlinearTimeIndicator,
                });

                return;
            }

            if (expiry_time !== null) {
                setState({
                    timeLeftPercent: undefined,
                    showLinearTimeIndicator: false,
                });

                setToExpired();
            }
        },
        !price || isExpired ? null : 1000,
    );

    const hoveringText = intent === Intents.BUY ? 'Sell it' : 'Buy it';
    const isActiveOrder = price && !isExpired;

    return (
        <div
            className={calcTableItemClass()}
            onClick={isActiveOrder ? (isOwner ? getOrder : placeOrder) : showCreateOrder}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div />
            <div className={`TableItemText${hovering ? ' Hovering' : ''}`}>
                <div className="TableItemPrice">{isActiveOrder ? price : ''}</div>
                {isActiveOrder ? <div className="TableItemTextHover">{hoveringText}</div> : null}
            </div>
            {state.showLinearTimeIndicator ? (
                <div className="linearTimeIndicator" style={{ width: `${state.timeLeftPercent}%` }} />
            ) : (
                <div />
            )}
        </div>
    );
};

export { GridTableCell };



// WEBPACK FOOTER //
// ./source/components/OnlineMarketsGridViewTableCell.js